<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.CREATE') }} {{ $t('ITEM.ITEM') }}
      <v-spacer></v-spacer>
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <item-form
        v-model="form"
        :errors="errors.getAll()"
        @update-prop="clearErrorByName($event)"
      />
      <v-card-actions>
        <v-btn outlined depressed large color="grey" @click="cancel">
          {{ $t('BUTTON.CANCEL') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          large
          depressed
          color="success"
          :disabled="!isValid"
          @click="create"
        >
          {{ $t('BUTTON.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import multiValid from '@/modules/_global/mixins/multiple-valid';
import { DocumentsListsItemsService } from '@/services/documents-lists-items.service';
import ItemForm from '@/modules/documents_lists/components/forms/ItemForm';

export default {
  name: 'ItemCreate',

  components: {
    ItemForm
  },

  mixins: [errors, multiValid],

  props: {
    listId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      form: {
        type_id: null,
        children: null,
        contentable_id: null,
        translations: []
      },
      valid: true
    };
  },

  methods: {
    ...mapActions('snackbar', ['setSnack']),
    cancel() {
      this.$emit('cancel');
    },
    create() {
      DocumentsListsItemsService.create(this.listId, this.form)
        .then(({ data }) => {
          this.setSnack({
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('created', data.data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
